'use client';

import * as tracker from '@/infra/tracking/events';
import { useRunOnce } from '@/presenters/hooks/use-run-once';
import { useServiceState } from '@/presenters/store/catalog/service';

export default function GTMServicePageView() {
  const service = useServiceState((state) => state.service);

  useRunOnce(() => {
    tracker.pushViewItem({
      item: {
        id: service._id,
        name: service.name,
        type: 'service',
        price: service.price.to,
        brand: 'Leroy Merlin',
        categoryTree: 'serviço',
        seller: 'Leroy Merlin',
        quantity: 1,
      },
    });
  }, Boolean(service));

  return null;
}
